import {SignUpButton} from '@clerk/clerk-react'
import {Button} from '@/components/ui/button'
import { SlideIn, StaggerContainer, StaggerItem, ViewportReveal } from "@/components/motion";

export function ReadyCtaSection() {
    return (
        <section className="bg-gradient-to-r from-[#2b42a3] via-[#334ec5] to-[#4669ed] px-4 py-24 text-white sm:px-6 lg:px-8">
            <ViewportReveal animation="scale" className="mx-auto w-2/3 space-y-8 text-center">
                <SlideIn direction="up" delay={0.1}>
                    <h2 className="text-6xl font-extrabold">Ready to Grow With Us?</h2>
                </SlideIn>
                <SlideIn direction="up" delay={0.2}>
                    <p className="text-xl font-normal text-white/90">
                        Whether you&apos;re an AI expert looking to develop your career or a business seeking continuously-trained
                        consultants, we&apos;re here to help you succeed.
                    </p>
                </SlideIn>
                <SlideIn direction="up" delay={0.3}>
                    <div className="flex flex-wrap justify-center gap-4">
                        <SignUpButton mode="modal">
                            <Button className="rounded-full bg-white px-8 py-6 text-base font-semibold text-[#334ec5] hover:bg-white/90">
                                Apply as Expert
                            </Button>
                        </SignUpButton>
                        <SignUpButton mode="modal">
                            <Button
                                variant="outline"
                                className="rounded-full border-2 border-white/70 bg-transparent px-8 py-6 text-base font-semibold text-white hover:bg-white/10"
                            >
                                Hire AI Experts
                            </Button>
                        </SignUpButton>
                    </div>
                </SlideIn>
                <StaggerContainer staggerDelay={0.1} delayChildren={0.4} className="flex flex-col gap-3 text-sm font-semibold text-white/80 sm:flex-row sm:justify-center sm:gap-8">
                    <StaggerItem className="flex items-center justify-center gap-2">
                        <span>✓</span> No application fee
                    </StaggerItem>
                    <StaggerItem className="flex items-center justify-center gap-2">
                        <span>✓</span> 48-hour response time
                    </StaggerItem>
                    <StaggerItem className="flex items-center justify-center gap-2">
                        <span>✓</span> Free consultation call
                    </StaggerItem>
                </StaggerContainer>
            </ViewportReveal>
        </section>
    )
}

